import Background from "../assets/wallet-background.png";
import Challenges from "./Challenges";
import { Col } from "antd";
import CommunityDetail from "./CommunityDetail";
import DrawerDetails from "./DrawerDetails";
import { Link } from "react-router-dom";
import NFTs from "./NFTs";
import Radium from "radium";
import Ranking from "./Ranking";
import User from "./User";
import logo from "../assets/opis-logo.svg";

const CommunityDashboard = ({ nftSection, challengesSection, tokenList }) => {
  return (
    <Col xs={24} sm={24} md={19} lg={18} xl={14} xxl={16} style={styles.mainLayout}>
      <section style={styles.mainLayout.mobileSection}>
        <Link to="/">
          <img src={logo} alt="opis" />
        </Link>
        <div style={styles.mainLayout.mobileSection.drawer}>
          <DrawerDetails
            children={
              <Col style={styles.drawer.children}>
                <User />
                <Ranking />
              </Col>
            }
          />
        </div>
      </section>
      <CommunityDetail />
      <Challenges challengesSection={challengesSection} />
      <NFTs tokenList={tokenList} nftSection={nftSection} />
    </Col>
  );
};

export default Radium(CommunityDashboard);

const query = {
  xs: "@media (max-width: 576px)",
  sm: "@media (max-width: 767px)",
  md: "@media (max-width: 992px)",
  lg: "@media (max-width: 1200px)",
  xl: "@media (max-width: 1600px)",
  small: "@media (max-width: 600px)",
  medium: "@media (max-width: 1440px)",
  large: "@media (max-width: 1700px)",
};

const styles = {
  mainLayout: {
    backgroundColor: "#78D5041A",
    borderRadius: "25px",
    marginTop: "16px",
    paddingTop: "16px",
    mobileSection: {
      display: "none",
      justifyContent: "space-between",
      padding: " 8px 16px 8px",
      overflow: "hidden",
      [query.sm]: { display: "flex" },
      drawer: { position: "fixed", right: "16px", zIndex: 2 },
    },
  },
  drawer: {
    display: "none",
    position: "fixed",
    right: "16px",
    zIndex: 1,
    [query.lg]: { display: "block" },
    [query.sm]: { display: "none" },
    children: {
      backgroundColor: "rgb(120, 213, 4,0.9)",
      backgroundImage: `url(${Background})`,
      backgroundPosition: "20% 0",
      backgroundSize: "cover",
      minHeight: "90vh",
      height: "100%",
      maxWidth: "300px",
      width: "100%",
      padding: "16px",
      overflowY: "hidden",
    },
  },
};
